import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordComponent } from './password.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, NG_VALIDATORS } from '@angular/forms';

@NgModule({
  declarations: [PasswordComponent],
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
  ],
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PasswordComponent
  }],
  exports: [
    PasswordComponent
  ]
})
export class EppPasswordModule { }
